import {Draggable, gsap, InertiaPlugin, MotionPathPlugin} from "gsap/all";
import $ from "jquery";
import {BaseGameMars} from "../base/BaseGameMars";
import {Gauge} from "./Gauge";
import {TeamBuilder} from "../build-your-team/TeamBuilder";
import {TeamReport} from "./TeamReport";
import {InstructionsPill} from "./InstructionsPill";
import {ScrollIndicator} from "./ScrollIndicator";

// Constructor
export class BuildYourTeam extends BaseGameMars {

  constructor() {
    super(`data/build-your-team.json`, 'build-your-team');
    gsap.registerPlugin(MotionPathPlugin, Draggable, InertiaPlugin);

    this.currentTimeline = gsap.timeline();
    this.teamGauge = {};
    this.memberGauges = [];
    this.isDraggingMembers = false;
    this.lastCrewNameParts = [];
    this.hasNewTeamToShowcase = false;

    this.idleModeHeadlineCounter = 0;
    this.idleModeImageCounter = 0;
  }

  initGame() {

    // Audio example
    // setInterval(() => app.audio.play("audio/click.wav", 1, true), 1000)

    this.teamBuilder = new TeamBuilder(this);
    this.teamReport = new TeamReport(this);
    this.instructionsPill = new InstructionsPill($("#screen-4 .instructions-pill"));
    this.init();
    this.scrollIndicator = new ScrollIndicator($("#screen-4 .group-members .listing"), $("#screen-4 .group-members .scroll-indicator"));
    this.initGauges();

    super.initGame();

    // TODO Remove debug script (jump into game)
    // this.selectCrewType("science_crew")
    // super.initGame(4);
    // this.beforeStep(2);
    // this.beforeStep(3);
    // this.beforeStep(4);
    // for (let memberId of ["member1", "member2", "member3", "member4"]) this.teamBuilder.addMember(memberId)

    // TODO Remove debug script (jump to crew selection screen)
    // super.initGame(3);

    // TODO Remove debug script (jump to final screen)
    // this.selectCrewType("science_crew")
    // for (let memberId of ["member1", "member2", "member3", "member4"]) this.teamBuilder.addMember(memberId)
    // super.initGame(7);

  }

  init() {
    $(".group-members .listing").each((i, el) => {
      const $el = $(el);

      let scrollTarget = el.scrollTop;
      let isWheelScrolling = false;

      $el.on('wheel', (e) => {
        e.preventDefault();

        // Start from where the list really is when something else scrolled it
        // since the last wheel turn (a drag, the hint button). Wheel turns that
        // follow each other keep adding to the same target.
        if (!isWheelScrolling) scrollTarget = el.scrollTop;

        const max = el.scrollHeight - el.clientHeight;
        scrollTarget = gsap.utils.clamp(0, max, scrollTarget + e.originalEvent.deltaY);

        const wheelEnded = () => isWheelScrolling = false;
        gsap.to(el, {
          scrollTop: scrollTarget,
          duration: 0.6,
          ease: "power2.out",
          overwrite: true,
          onComplete: wheelEnded,
          onInterrupt: wheelEnded
        });

        // Set after creating the tween, since overwriting the previous one
        // interrupts it and clears the flag
        isWheelScrolling = true;
      });

      Draggable.create(el, {
        type: "scroll",
        inertia: true,
        dragClickables: false,
        allowNativeTouchScrolling: false,
        cursor: "auto",
        // A finger on the list stops any tween scrolling it (hint, wheel), so
        // the drag doesn't fight it
        onPress: () => gsap.killTweensOf(el),
        onDragStart: () => {
          this.isDraggingMembers = true;
        },
        onDragEnd: () => {
          setTimeout(() => {
            this.isDraggingMembers = false;
          }, 50);
        }
      });
    });
  }

  initScreen(screenId) {
    const targetScreenNoSuffix = parseInt(screenId.toString().split("-")[0]);

    if (targetScreenNoSuffix === 1) {
      gsap.set($("#frame-top"), {alpha: 0});

      // Animate "new" idle screen frame
      if (this.hasNewTeamToShowcase) {
        gsap.fromTo($("#screen-1 .frame").first(), {opacity: 0, x: -100, filter: "blur(90px)"}, {opacity: 1, x: 0, filter: "blur(0px)", duration: 1.5});
        this.hasNewTeamToShowcase = false;
      }

    } else if (targetScreenNoSuffix === 2) {
      if (!this.shipMotionStarted) {
        this.shipMotionStarted = true;
        this.shipTimeline = this.initShipTimeline();
      }

    } else if (targetScreenNoSuffix === 3) {
      gsap.to($(".loading"), {alpha: 1});

    } else if (targetScreenNoSuffix === 4) {
      this.beforeStep(1); // Fade out UI while lockScreen is on
      gsap.set($("#frame-bottom, #frame-top"), {alpha: 0});
      gsap.set($(".overlay-aptitudes"), {autoAlpha: 0});

      for (let memberGauge of this.memberGauges) {
        const value = parseFloat($(memberGauge.container).data("value"));
        memberGauge.animateToLevel(value);
      }

    } else if (targetScreenNoSuffix === 5) {
      gsap.set($("#frame-bottom, #frame-top, .loading"), {alpha: 0});
      gsap.to($("#frame-bottom, #frame-top, .loading"), {alpha: 1});

      this.teamBuilder.cancelHintCall();
      this.randomCrewName();
      this.warmUpScreenVideos();
    } else if (targetScreenNoSuffix === 6) {
      this.playScreenVideos();
    } else if (targetScreenNoSuffix === 7) {
      gsap.set($("#frame-top, #frame-bottom"), {alpha: 0});
      if (this.teamBuilder.selectedMembers.length) {
        this.teamReport.renderTeamReport(this.teamBuilder.selectedMembers, this.teamBuilder.getTeamTopAptitudes(), this.teamBuilder.requirementCounts, this.teamBuilder.aptitudeSums);
      }

      this.initFinalShipTimeline();

      // Updated screen saver teams showcase
      this.addTeamToScreenSaver(this.lastCrewNameParts.join(" "), this.lastCrewType)
    }
  }

  // Used for tutorial uniformity with Rover, which is kind of weird in this case since we have a single step
  beforeStep(stepId) {
    if (stepId === 1) {
      this.$currentScreen.addClass("step-active");
      gsap.set($(".group-member-info, .members-shapes", "#screen-4"), {opacity: 0.3, pointerEvents: "none"});
      gsap.set($(".group-top, .group-team-aptitudes, .group-team-requirements, .group-team-selected", "#screen-4 .top-screen"), {opacity: 0.3, pointerEvents: "none"});

    } else if (stepId === 4) {
      this.$currentScreen.removeClass("step-active");
    }

    // Steps 2 and 3 are real step changes: goToStep calls initStep itself once
    // the previous tool tip has faded out, and calling it here too would start
    // the glow twice. Step 1 (arriving on the screen) and 4 (no step 4 element,
    // the tutorial ends) never go through that, so they need it here.
    if (stepId === 1 || stepId === 4) this.initStep(stepId);
  }

  // Used for tutorial uniformity with Rover, which is kind of weird in this case since we have a single step
  initStep(stepId) {
    this.killTimeline(this.currentTimeline)
    this.currentTimeline = gsap.timeline();

    function highlightOn(selector, tl) {
      tl.to($(selector), {
        boxShadow: "0px 0px 103.7px 0px #FFFFFF",
        duration: 0.3,
        autoAlpha: 1,
        ease: "power1.out",
        pointerEvents: "none"
      });
    }

    function highlightOff(selector, tl, opacity = 0.3) {
      tl.to($(selector), {
        boxShadow: "0px 0px 0px rgba(0,0,0,0)",
        duration: 0.3,
        autoAlpha: opacity,
        ease: "power1.out",
        clearProps: "boxShadow",
        pointerEvents: (opacity === 1) ? "auto" : "none"
      });
    }

    if (stepId === 1) {
      highlightOn($(".group-members", "#screen-4"), this.currentTimeline);

    } else if (stepId === 2) {
      highlightOff($(".group-members", "#screen-4"), this.currentTimeline);
      highlightOn($(".group-team-requirements", "#screen-4 .top-screen"), this.currentTimeline);

    } else if (stepId === 3) {
      highlightOff($(".group-team-requirements", "#screen-4 .top-screen"), this.currentTimeline);
      highlightOn($(".group-team-aptitudes", "#screen-4 .top-screen"), this.currentTimeline);

    } else if (stepId === 4) {
      highlightOff($(".group-members, .top-screen .group-top, .top-screen .group-team-aptitudes, .top-screen .group-team-requirements, .top-screen .group-team-selected", "#screen-4"), this.currentTimeline, 1);
      this.currentTimeline.to($(".group-member-info, .members-shapes", "#screen-4"), {opacity: 1, pointerEvents: "auto"}, '<');

      // There is no step 4, so this is like completing tutorial (ending of step 3)
      this.currentTimeline.to($(".step.current"), {
        y: 0,
        alpha: 0,
        duration: 0.3,
        ease: "power1.out"
      }, "<");
      this.currentTimeline.add(() => $(".step").removeClass("current"));
      this.currentTimeline.add(() => this.instructionsPill.show());
      this.currentTimeline.add(() => this.teamBuilder.scheduleHintCall());
    }
  }

  initGauges() {
    $(".group-team-aptitudes .aptitude").each((i, el) => {
      const $el = $(el);
      const id = $el.data("id");

      if (!this.teamGauge[id]) {
        this.teamGauge[id] = new Gauge($el.find(".gauge-container"));
      }
    });

    $(".group-members .aptitude .gauge-container, .group-member-info .aptitude .gauge-container").each((i, el) => {
      const gauge = new Gauge($(el));
      this.memberGauges.push(gauge);
    });
  }

  initShipTimeline() {
    const shipGroup = $("#shipMotionGroup");
    const ship = $("#ship");

    if (shipGroup.length === 0 || ship.length === 0) return null;

    gsap.set(shipGroup, {
      opacity: 0,
      scale: 0.6,
      transformOrigin: "50% 50%"
    });

    gsap.set(ship, {
      scale: 0.6,
      transformOrigin: "50% 50%"
    });

    return gsap.timeline({
      delay: 0.5,
      repeat: -1
    })
      .to(shipGroup, {
        opacity: 1,
        scale: 1,
        duration: 0.6,
        ease: "back.out(1.7)"
      })
      .to(ship, {
        scale: 1.3,
        duration: 30,
        ease: "none"
      }, 0)
      .to(shipGroup, {
        duration: 30,
        ease: "none",
        motionPath: {
          path: "#flightPath",
          align: "#flightPath",
          autoRotate: true,
          alignOrigin: [0.5, 0.5]
        }
      }, 0);
  }

  initFinalShipTimeline() {
    if (this.shipPathStarted) return;

    const $ship = $(".ship-path-events .ship");
    const $lineSolid = $(".ship-path-events .line-solid");

    if (!$ship.length || !$lineSolid.length) return;

    const ship = $ship[0];
    const lineSolid = $lineSolid[0];

    this.shipPathStarted = true;

    const pathLength = lineSolid.getTotalLength();
    const pathStart = lineSolid.getPointAtLength(0);
    const pathEnd = lineSolid.getPointAtLength(pathLength);

    const SHIP_Y_OFFSET = -38;

    gsap.set(lineSolid, {
      attr: {"stroke-dasharray": pathLength, "stroke-dashoffset": pathLength}
    });

    gsap.set(ship, {x: pathStart.x, y: pathStart.y + SHIP_Y_OFFSET, opacity: 0, scale: 0.6, transformOrigin: "50% 50%"});

    // For each event marker on the line, figure out where along the
    // (time) journey the ship will reach it,
    // and remember that, so later we know when to reveal it.
    this.shipPathEvents = $(".ship-path-events .path-event").toArray().map((el) => {
      const bbox = el.getBBox();
      const cx = bbox.x + bbox.width / 2;
      const progress = Math.min(Math.max((cx - pathStart.x) / pathLength, 0), 1);
      const circles = $(el).find("circle");
      const eventNumber = el.id.replace("path-event", "");
      const $eventText = $(`#event_${eventNumber}`);

      gsap.set(el, {opacity: 0});
      gsap.set(circles, {scale: 0, transformOrigin: "50% 50%"});
      gsap.set($eventText, {opacity: 0, scale: 0, transformOrigin: "50% 50%"});

      return {el, circles, $eventText, progress};
    });

    this.shipPathTimeline = gsap.timeline()
      .to(ship, {opacity: 1, scale: 1, duration: 0.4, delay: 0.8, ease: "back.out(1.7)"})
      .addLabel("travel")
      .to(ship, {x: pathEnd.x, y: pathEnd.y + SHIP_Y_OFFSET, duration: 5, ease: "none"}, "travel")
      .to(lineSolid, {attr: {"stroke-dashoffset": 0}, duration: 5, ease: "none"}, "travel");

    this.shipPathEvents.forEach(({el, circles, $eventText, progress}) => {
      const at = `travel+=${(progress * 5).toFixed(3)}`;

      this.shipPathTimeline
        .to(el, {opacity: 1, duration: 0.4}, at)
        .to(circles, {scale: 1, duration: 0.4, ease: "back.out(1.7)"}, at)
        .to($eventText, {opacity: 1, scale: 1, duration: 0.4, ease: "back.out(1.7)"}, at);
    });
  }

  // Used by screen 1 CTA
  animateToScreen2() {
    this.lockInteraction();
    this.killTimeline(this.currentTimeline);
    this.currentTimeline = gsap.timeline()

    // Animate top screen frame overlay
    this.currentTimeline.fromTo($("#frame-top"), {scale: 1.05}, {alpha: 1, scale: 1, ease: 'sine.inOut', duration: 0.3});

    // Animate UI element out
    this.currentTimeline.to($("#screen-1 .bottom-screen > div"), {alpha: 0, duration: 0.3, ease: 'sine.inOut'}, '<');

    // Actually go to screen 2
    this.currentTimeline.add(() => this.goToScreen(2, null, true));
  }

  // Used by screen 4 reset button
  resetTeamSelection() {
    this.lockInteraction();
    this.killTimeline(this.currentTimeline);
    this.currentTimeline = gsap.timeline()

    // Animate UI element out
    this.currentTimeline.to($(".screen.current .group-members"), {alpha: 0, x: -20, duration: 0.3, ease: 'sine.inOut'});
    this.currentTimeline.to($(".screen.current .group-member-info"), {alpha: 0, x: 20, duration: 0.3, ease: 'sine.inOut'}, '<');

    // Hide bottom screen frame overlay
    this.currentTimeline.fromTo($("#frame-bottom"), {scale: 1.05}, {alpha: 1, scale: 1, duration: 0.3}, 0.3);
    this.currentTimeline.to($("#frame-top"), {alpha: 1, scale: 1, duration: 0.3}, "<");

    // Actually go to screen 3
    this.currentTimeline.add(() => this.reset(3));
  }

  openInfoModal() {
    this.currentTimeline.to($(".overlay-aptitudes"), {autoAlpha: 1});
  }

  closeModal(item) {
    this.currentTimeline.to($(".overlay-aptitudes"), {autoAlpha: 0});
  }

  // Select a crew type in screen 3
  selectCrewType(crewId) {
    if (!crewId) return;

    this.lastCrewType = crewId;

    this.killTimeline(this.currentTimeline);
    this.currentTimeline = gsap.timeline();

    const $target = $(`.crew-screen .crew-item[data-crew-id="${crewId}"]`);
    const $others = $(".crew-screen .crew-item").not($target);
    const $children = $target.find(".crew-image, .text-modal-1, .text-modal-2");

    gsap.set($children, {alpha: 0});

    this.currentTimeline.to($(".loading"), {alpha: 0})
    this.currentTimeline.to($others, {alpha: 0}, "<")
    this.currentTimeline.to($target, {alpha: 1});

    this.currentTimeline.to($children, {
      alpha: 1,
      stagger: 0.25,
      ease: "power1.in"
    }, '<');

    // Updated select options
    $(`.crew-pill-button[data-action-arg="${crewId}"]`).addClass("is-active");
    $(".crew-pill-button").not(`[data-action-arg="${crewId}"]`).removeClass("is-active");

    // Enable going to next screen
    $("#screen-3 .bottom-screen .pill-button").removeClass("not-active");

    // Update next screens
    this.teamBuilder.selectCrewType(crewId)
    this.teamReport.selectCrewType(crewId)
  }

  randomCrewName() {

    // Build selection into this.lastCrewNameParts
    for (let i = 1; i <= 2; i++) {
      const allPartOptions = this.data.content.team_names["part" + i];
      const availableOptions = (this.lastCrewNameParts.length === 0) ? allPartOptions : allPartOptions.filter((name) => !this.lastCrewNameParts.includes(name));
      this.lastCrewNameParts[i] = availableOptions[Math.floor(Math.random() * availableOptions.length)];
    }
    const randomName = this.lastCrewNameParts.join(" ");

    BaseGameMars.killTimeline(this.currentTimeline)
    this.currentTimeline = gsap.timeline();
    this.currentTimeline.to(".input-name-random .input-name", {
      opacity: 0,
      duration: 0.15,
      ease: "power1.out"
    })
    this.currentTimeline.call(() => $(".input-name-random .input-name").text(randomName))
    this.currentTimeline.to(".input-name-random .input-name", {
      opacity: 1,
      duration: 0.25,
      ease: "power1.out"
    });

    return randomName;
  }

  addTeamToScreenSaver(teamName, teamType) {

    // Get last idle frame
    const $frame = $("#screen-1 .frame").last();

    // Get values for "template"
    const teamData = this.data.content.team_role[teamType];
    this.idleModeHeadlineCounter = (this.idleModeHeadlineCounter + 1) % teamData.idle_mode_headlines.length
    const idleModeHeadline = teamData.idle_mode_headlines[this.idleModeHeadlineCounter];
    this.idleModeImageCounter = (this.idleModeImageCounter + 1) % teamData.idle_mode_images.length
    const idleModeImage = teamData.idle_mode_images[this.idleModeImageCounter];

    // Update team type (gradient color), text and icon
    $frame.attr("data-crew-id", teamType);
    $frame.find(".text .fr").html(`${teamData.title.fr}<h3>The ${teamName} ${idleModeHeadline.fr}</h3>`);
    $frame.find(".text .en").html(`${teamData.title.en}<h3>The ${teamName} ${idleModeHeadline.en}</h3>`);
    $frame.find(".frame-icon").attr("src", teamData.image);
    $frame.find(".frame-image").attr("src", idleModeImage);

    // Move last item to front row
    $frame.parent().prepend($frame);

    this.hasNewTeamToShowcase = true;
  }

  // Starts the decoders and decodes frame 1 while screen 6 is still hidden, so the
  // first play doesn't stutter. Done just before, as Chromium frees idle decoders.
  warmUpScreenVideos() {
    $("#screen-6 .screen-video").each((i, video) => {
      $(video).one("playing.warmUp", () => {
        video.pause();
        video.currentTime = 0;
      });

      video.currentTime = 0;
      video.play().catch(() => {
      }); // Interrupted by the pause above, expected
    });
  }

  // Plays both videos, then moves on to the report when the bottom one ends (same length)
  playScreenVideos() {
    // A warm-up still waiting to pause would stop the real playback
    $("#screen-6 .screen-video").off(".warmUp");

    $("#screen-6 .bottom-screen .screen-video").on("timeupdate.screenVideo", () => this.resetTimer());

    $("#screen-6 .bottom-screen .screen-video").on("ended.screenVideo", () => {
      this.stopScreenVideos();
      this.goToNextScreen();
    });

    $("#screen-6 .screen-video").each((i, video) => {
      video.currentTime = 0;
      video.play();
    });
  }

  stopScreenVideos() {
    $("#screen-6 .screen-video").off(".screenVideo .warmUp").each((i, video) => video.pause());
  }

  getScreenSaverDelay() {
    return this.screensaverDelay + this.data.screensaver_additionnal_delay_sec;
  }

  /**
   * @param screenId
   */
  reset(screenId) {

    this.stopScreenVideos();
    this.teamBuilder.cancelHintCall();
    this.killTimeline(this.currentTimeline);
    this.currentTimeline = gsap.timeline();

    gsap.set($("#frame-bottom"), {alpha: 1});
    gsap.set($(".loading"), {alpha: 1});
    gsap.set($("#screen-1 .bottom-screen > div"), {clearProps: "all"});

    // Screen 2: let the ship motion play again from start
    if (this.shipTimeline) {
      this.shipTimeline.kill();
      this.shipTimeline = null;
    }
    this.shipMotionStarted = false;
    gsap.set($("#shipMotionGroup"), {clearProps: "all"});

    // Screen 3: clear any previously selected crew
    $(".crew-pill-button").removeClass("is-active");
    $(".crew-screen .crew-item").css("opacity", "0");
    $("#screen-3 .bottom-screen .pill-button").addClass("not-active");

    const resetCallback = () => {
      this.teamBuilder.reset();
      this.teamReport.reset();
      this.instructionsPill.hide();

      // Screen 4: experts' list back to the top
      $(".group-members .listing").each((i, el) => {
        gsap.killTweensOf(el);
        el.scrollTop = 0;
        Draggable.get(el)?.update();
      });

      this.lastCrewNameParts = [];
      this.lastCrewType = null;

      // Reset team gauges
      for (const id in this.teamGauge) this.teamGauge[id].reset();

      // Screen 6: rewind the videos while hidden, so they don't jump to frame 1 on arrival
      $("#screen-6 .screen-video").each((i, video) => video.currentTime = 0);

      // Screen 6: let the ship-path-events animation replay from the start
      if (this.shipPathTimeline) {
        this.shipPathTimeline.kill();
        this.shipPathTimeline = null;
      }
      this.shipPathStarted = false;
      this.shipPathEvents = null;
      gsap.set($(".ship-path-events .ship"), {clearProps: "all"});
      gsap.set($(".ship-path-events .line-solid"), {clearProps: "all"});
      gsap.set($(".ship-path-events .path-event"), {clearProps: "all"});
      gsap.set($(".ship-path-events .path-event circle"), {clearProps: "all"});
      gsap.set($(".group-members, .group-member-info"), {clearProps: "all"});
      $(".ship-path-events .path-event").each((i, el) => {
        const eventNumber = el.id.replace("path-event", "");
        gsap.set($(`#event_${eventNumber}`), {clearProps: "all"});
      });
    }

    return super.reset(screenId, resetCallback);
  }
}
